module.exports = __webpack_public_path__ + "img/marholidays.1869d7ba.png";